import { render, staticRenderFns } from "./UserList.vue?vue&type=template&id=4a448355&scoped=true&"
import script from "./UserList.vue?vue&type=script&lang=ts&"
export * from "./UserList.vue?vue&type=script&lang=ts&"
import style0 from "./UserList.vue?vue&type=style&index=0&id=4a448355&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a448355",
  null
  
)

export default component.exports